import h from 'react-hyperscript';
import moment from 'moment-timezone';
import { routeMap } from '../../routes';
import history from '../../history';

const TermsOfServiceRedirect = ({ data }) => {
  const { loading = false, me = null } = data || {};

  if (loading) {
    return '';
  }

  if (!me) {
    return h('pre', 'Sorry, but we have encountered a problem. Please refresh the page and try again.');
  }

  const mDate = moment(me.terms_of_service_approval);

  if (!me.terms_of_service_approval || mDate.isValid() === false || mDate.isAfter(moment())) {
    // Not approved, redirect
    history.push(routeMap.TERMS_OF_SERVICE_APPROVAL.path);

    return null;
  }

  return '';
};

export default TermsOfServiceRedirect;



// WEBPACK FOOTER //
// ./src/components/TermsOfService/TermsOfServiceRedirect.js